<template>
  <div class="w-11/12">
    <div class="flex justify-center">
      <img
        :src="require('@/assets/projects/' + project.logo)"
        :class="project.logo_size"
      />
    </div>
    <div class="font-semibold text-gray-800 tracking-wider mt-6">
      {{ project.name }}
    </div>
    <div class="font-light text-gray-600 tracking-wider mt-6 text-sm"></div>

    <div class="w-full text-center">
      <p class="mt-6 text-gray-600 text-xs">{{ project.desc }}</p>
    </div>

    <div class="w-full text-center" v-if="!hideReadMore">
      <p class="mt-8 text-gray-600 text-xs font-semibold">Read more</p>
    </div>
    <div v-if="viewAll" class="mt-10">
      <div class="text-sm text-gray-700" v-html="project.brief"></div>
      <image-container :images="project.images" :img_size="project.img_size" />
      <div v-if="project.link">
        <a :href="project.link" target="_blank">{{ project.link }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import ImageContainer from "./ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    project: {
      type: Object,
    },
    hideReadMore: {
      default: false,
    },
    viewAll: {
      default: false,
    },
  },
  mounted() {
    console.log(this.project.logo);
  },
};
</script>
<style scoped>
.sm {
  max-width: 20% !important;
  margin: 0 auto;
}
.lg {
  max-width: 70% !important;
  margin: 0 auto;
}
</style>